import { useAuth0 } from "@auth0/auth0-react";
import SearchDownShift from "components/downmshift/DownShift";
import SearchAutoComplete from "components/SearchAutoComplete";
import { useFormik } from "formik";
import FinanceSettingService from "Lib/API/FinanceSetting/FinanceSetting";
import { debounce } from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { ToastHeader } from "react-bootstrap";
import { toastr } from "react-redux-toastr";
import { useHistory, useLocation } from "react-router-dom";
import NotAuthorized from "../../../../components/NotAuthorized";
import ComponentHeading from "../../componentHeading/ComponentHeading";
import LeftMenu from "../../leftMenu/LeftMenu";
import SettingHeader from "../../SettingHeader/settingHEader";

const AccountReceivable = ({ heading }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [disable, setDisable] = useState(false);
  const [type, setType] = useState("");
  const [receivableAccounts, setReceivableAccounts] = useState([]);
  const [curruntId, setCurruntId] = useState(undefined);
  const [disableAddNew, setDaisableAddNew] = useState(false);
  const [addNew, setAddNew] = useState(false);
  const [IsSettingsActive, setIsSettingsActive] = useState(true);
  const [edit, setEdit] = useState(false);
  const [addPath, setAddPath] = useState();
  const [accountsData, setAccountsData] = useState({});
  const [searchValue, setSearchValue] = useState("");
  const formik = useFormik({
    enableReinitialize: true,
    initialValues:
      addNew === true
        ? {
            ar_name: "",
            ar_id: "",
          }
        : {
            ar_name: accountsData?.ar_name ?? accountsData[0]?.ar_name,
            ar_id: accountsData?.ar_id ?? accountsData[0]?.ar_id,
          },
  });
  const getReceivableAccounts = async () => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.getAllAccountReceivable(token)
      .then((res) => {
        setReceivableAccounts(res?.result);

        setType(res?.result[0]?.ar_name);
        setCurruntId(res?.result[0]?._id);
      })
      .catch((e) => {
        toastr.error(e?.data?.message ?? "Error");
      });
  };
  const getReceivableAccountsByID = async (type, id) => {
    setType(type);
    setCurruntId(id);
    const token = await getAccessTokenSilently();
    await FinanceSettingService.getReceivableAccountsByID(token, id)
      .then((res) => {
        setAccountsData(res?.result);
      })
      .catch((e) => {
        toastr.error(e?.data?.message ?? "Error");
      });
  };
  const disableReceivableAccount = async (type, id) => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.disableReceivableAccount(
      token,
      curruntId ?? receivableAccounts[0]?._id
    )
      .then(() => {
        toastr.success("success");
        getReceivableAccounts();
        setType("");
        setCurruntId("");
      })
      .catch((e) => {
        toastr.error(e?.data?.message ?? "Error");
      });
    initialStage();
  };
  const option2 = receivableAccounts?.map((item, index) => ({
    id: item?._id,
    name: item?.ar_name ?? item?.ar_name,
  }));
  const newAccountReceivable = async () => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.createNewAccountReceivable(
      {
        ar_name: formik.values?.ar_name,
        ar_id: formik.values?.ar_id,
      },
      token
    )
      .then(() => {
        toastr.success("Success", "New Type has been created");
        getReceivableAccounts();
        push({
          pathname: "/financial-setting/accounts-receivable/view",
        });
      })
      .catch((e) => {
        toastr.error(e?.data?.message ?? "Error");
      });
  };
  const initialStage = () => {
    formik.setFieldValue("payement_type_new", receivableAccounts[0]?.type);
    formik.setFieldValue(
      "default_payment_type",
      receivableAccounts[0]?.is_default
    );
  };
  const updateReceivableAccountId = async (data) => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.updateReceivableAccountId(
      token,
      curruntId ?? receivableAccounts[0]?._id,
      data
      // {
      //   is_default: formik.values?.default_payment_type,
      // }
    )
      .then((res) => {
        getReceivableAccounts();
        push({
          pathname: "/financial-setting/accounts-receivable/view",
        });
        toastr.success("success", "Updated Successfully");
      })
      .catch((e) => {
        toastr.error(e?.data?.message ?? "Error");
      });
    initialStage();
  };

  useEffect(() => {
    getReceivableAccounts();
  }, []);

  const { pathname } = useLocation();
  const { push } = useHistory();
  useEffect(() => {
    if (pathname.includes("view")) {
      setEdit(false);
      setDaisableAddNew(false);
      setDisable(false);
      setAddNew(false);
    }
  }, [pathname]);
  const debounceSearch = useCallback(
    debounce(async () => {
      if (searchValue) {
        const token = await getAccessTokenSilently();
        await FinanceSettingService.searchReceivableAccounts(
          searchValue,
          token
        ).then((res) => {
          setReceivableAccounts(res.result);
        });
      }
    }, 1000),
    [searchValue]
  );

  useEffect(() => {
    if (searchValue === "") {
      getReceivableAccounts();
    } else {
      setSearchValue(searchValue);
    }
  }, [searchValue]);
  useEffect(() => {
    debounceSearch();
    return () => {
      debounceSearch.cancel();
    };
  }, [debounceSearch, searchValue]);

  let orgInfo =
    localStorage.getItem("authorizedModules") !== undefined
      ? JSON.parse(localStorage.getItem("authorizedModules"))
      : [];

  useEffect(() => {
    let check = orgInfo?.map((item) => {
      if (item?.moduleName == "financial setting") {
        return setIsSettingsActive(item?.active);
      }
    });
  }, []);

  return IsSettingsActive == false ? (
    <NotAuthorized title={"Reports"} />
  ) : (
    <div className="w-100">
      <SettingHeader
        heading={heading}
        edit={edit}
        addNew={addNew}
        path={"/financial-setting/accounts-receivable/view"}
        setAddNew={setAddNew}
        parentHeading={"Financial"}
        alertOnEdit={edit}
      />
      <div className="main-setting__wrapper">
      <div className="col-md-4 mb-5 pl-7 pr-7">
        <SearchDownShift
          items={option2}
          name={searchValue}
          setName={setSearchValue}
          placeHolder="Search"
          autoFocus
        />
      </div>
      <div className="setting-main">
        <div className="left-menu-div">
          <LeftMenu
            accounts={receivableAccounts}
            btnText={"New Account Receivable"}
            getTypeId={getReceivableAccountsByID}
            disableAddNew={disableAddNew}
            setAddNew={setAddNew}
            setDisable={setDisable}
            setDaisableAddNew={setDaisableAddNew}
            addPath={addPath}
          />
        </div>
        <div className="settings-details">
          <ComponentHeading
            type={type}
            id={curruntId}
            heading={heading}
            disable={disable}
            setDisable={setDisable}
            setDaisableAddNew={setDaisableAddNew}
            edit={edit}
            addNew={addNew}
            setEdit={setEdit}
            setAddPath={setAddPath}
            updateFunc={updateReceivableAccountId}
            createFunc={newAccountReceivable}
            formik={formik}
            deleteFunc={disableReceivableAccount}
            accounts={receivableAccounts}
          />
        </div>
      </div>
      </div>
    </div>
  );
};

export default AccountReceivable;
